// extracted by mini-css-extract-plugin
export default {"tD":"CompanyPointsLiabilityReport_tD__xe0+4","tBODY":"CompanyPointsLiabilityReport_tBODY__sSRZh"};